import { TableWrapper } from 'modules/campaignAnalytics/components/Styled';
import styled from 'styled-components';
import { Link } from 'ui/links';
import TableHeader from 'ui/tableHeader/TableHeader';
import { TableRows } from 'ui/tableRows';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const CustomRepliesTableWrapper = styled(TableWrapper)`
  width: 100%;
`;

export const StyledLinkCell = styled(Link)`
  word-break: break-all;
  overflow-wrap: anywhere;
`;

const GRID_COLUMNS = `
  grid-template-columns: 
    minmax(${pxToRem(120)}, ${pxToRem(150)})       // Reply type
    minmax(${pxToRem(300)}, 1fr)                   // Content 
    minmax(${pxToRem(200)}, ${pxToRem(250)})       // User
    minmax(${pxToRem(160)}, ${pxToRem(180)});      // Timestamp
`;

export const StyledTableHeader = styled(TableHeader)`
  display: grid;
  ${GRID_COLUMNS};
   > div {
    display: flex;
      box-shadow: inset 0 0 ${colors.borderPrimary},
        inset 0 -${spacing.single} ${colors.borderPrimary};
      vertical-align: middle;
      height: ${spacing.x3};
    }
`;

export const StyledTableRows = styled(TableRows)`
  display: grid;
  ${GRID_COLUMNS};
`;
